export const SET_HEIGHT = 'SET_HEIGHT';
export const SET_WIDTH = 'SET_WIDTH';

export const SET_BACKGROUNDCOLOR = 'SET_BACKGROUNDCOLOR';
export const SET_COLOR = 'SET_COLOR';

export const SET_BORDERSTYLE = 'SET_BORDERSTYLE';
export const SET_BORDERSTYLE_TOP = 'SET_BORDERSTYLE_TOP';
export const SET_BORDERSTYLE_RIGHT = 'SET_BORDERSTYLE_RIGHT';
export const SET_BORDERSTYLE_BOTTOM = 'SET_BORDERSTYLE_BOTTOM';
export const SET_BORDERSTYLE_LEFT = 'SET_BORDERSTYLE_LEFT';

export const SET_BORDERWIDTH = 'SET_BORDERWIDTH';
export const SET_BORDERWIDTH_TOP = 'SET_BORDERWIDTH_TOP';
export const SET_BORDERWIDTH_RIGHT = 'SET_BORDERWIDTH_RIGHT';
export const SET_BORDERWIDTH_BOTTOM = 'SET_BORDERWIDTH_BOTTOM';
export const SET_BORDERWIDTH_LEFT = 'SET_BORDERWIDTH_LEFT';

export const SET_BORDERCOLOR = 'SET_BORDERCOLOR';
export const SET_BORDERCOLOR_TOP = 'SET_BORDERCOLOR_TOP';
export const SET_BORDERCOLOR_RIGHT = 'SET_BORDERCOLOR_RIGHT';
export const SET_BORDERCOLOR_BOTTOM = 'SET_BORDERCOLOR_BOTTOM';
export const SET_BORDERCOLOR_LEFT = 'SET_BORDERCOLOR_LEFT';

export const SET_BOXSHADOW = 'SET_BOXSHADOW';
export const SET_TEXTSHADOW = 'SET_TEXTSHADOW';

export const SET_BORDERRADIUS = 'SET_BORDERRADIUS';
export const SET_BORDERRADIUS_TOPLEFT = 'SET_BORDERRADIUS_TOPLEFT';
export const SET_BORDERRADIUS_TOPRIGHT = 'SET_BORDERRADIUS_TOPRIGHT';
export const SET_BORDERRADIUS_BOTTOMRIGHT = 'SET_BORDERRADIUS_BOTTOMRIGHT';
export const SET_BORDERRADIUS_BOTTOMLEFT = 'SET_BORDERRADIUS_BOTTOMLEFT';

export const SET_MARGIN = 'SET_MARGIN';
export const SET_MARGIN_TOP = 'SET_MARGIN_TOP';
export const SET_MARGIN_RIGHT = 'SET_MARGIN_RIGHT';
export const SET_MARGIN_BOTTOM = 'SET_MARGIN_BOTTOM';
export const SET_MARGIN_LEFT = 'SET_MARGIN_LEFT';

export const SET_PADDING = 'SET_PADDING';
export const SET_PADDING_TOP = 'SET_PADDING_TOP';
export const SET_PADDING_RIGHT = 'SET_PADDING_RIGHT';
export const SET_PADDING_BOTTOM = 'SET_PADDING_BOTTOM';
export const SET_PADDING_LEFT = 'SET_PADDING_LEFT';

export const SET_FONTSIZE = 'SET_FONTSIZE';
export const SET_FONTFAMILY = 'SET_FONTFAMILY';

export const SET_TEXT = 'SET_TEXT';
export const SET_SELECTOR = 'SET_SELECTOR';

export const SET_HOVER_HEIGHT = 'SET_HOVER_HEIGHT';
export const SET_HOVER_WIDTH = 'SET_HOVER_WIDTH';

export const SET_HOVER_BACKGROUNDCOLOR = 'SET_HOVER_BACKGROUNDCOLOR';
export const SET_HOVER_COLOR = 'SET_HOVER_COLOR';

export const SET_HOVER_BORDERSTYLE = 'SET_HOVER_BORDERSTYLE';
export const SET_HOVER_BORDERSTYLE_TOP = 'SET_HOVER_BORDERSTYLE_TOP';
export const SET_HOVER_BORDERSTYLE_RIGHT = 'SET_HOVER_BORDERSTYLE_RIGHT';
export const SET_HOVER_BORDERSTYLE_BOTTOM = 'SET_HOVER_BORDERSTYLE_BOTTOM';
export const SET_HOVER_BORDERSTYLE_LEFT = 'SET_HOVER_BORDERSTYLE_LEFT';

export const SET_HOVER_BORDERWIDTH = 'SET_HOVER_BORDERWIDTH';
export const SET_HOVER_BORDERWIDTH_TOP = 'SET_HOVER_BORDERWIDTH_TOP';
export const SET_HOVER_BORDERWIDTH_RIGHT = 'SET_HOVER_BORDERWIDTH_RIGHT';
export const SET_HOVER_BORDERWIDTH_BOTTOM = 'SET_HOVER_BORDERWIDTH_BOTTOM';
export const SET_HOVER_BORDERWIDTH_LEFT = 'SET_HOVER_BORDERWIDTH_LEFT';

export const SET_HOVER_BORDERCOLOR = 'SET_HOVER_BORDERCOLOR';
export const SET_HOVER_BORDERCOLOR_TOP = 'SET_HOVER_BORDERCOLOR_TOP';
export const SET_HOVER_BORDERCOLOR_RIGHT = 'SET_HOVER_BORDERCOLOR_RIGHT';
export const SET_HOVER_BORDERCOLOR_BOTTOM = 'SET_HOVER_BORDERCOLOR_BOTTOM';
export const SET_HOVER_BORDERCOLOR_LEFT = 'SET_HOVER_BORDERCOLOR_LEFT';

export const SET_HOVER_BOXSHADOW = 'SET_HOVER_BOXSHADOW';
export const SET_HOVER_TEXTSHADOW = 'SET_HOVER_TEXTSHADOW';

export const SET_HOVER_BORDERRADIUS = 'SET_HOVER_BORDERRADIUS';
export const SET_HOVER_BORDERRADIUS_TOPLEFT = 'SET_HOVER_BORDERRADIUS_TOPLEFT';
export const SET_HOVER_BORDERRADIUS_TOPRIGHT =
  'SET_HOVER_BORDERRADIUS_TOPRIGHT';
export const SET_HOVER_BORDERRADIUS_BOTTOMRIGHT =
  'SET_HOVER_BORDERRADIUS_BOTTOMRIGHT';
export const SET_HOVER_BORDERRADIUS_BOTTOMLEFT =
  'SET_HOVER_BORDERRADIUS_BOTTOMLEFT';

export const SET_HOVER_MARGIN = 'SET_HOVER_MARGIN';
export const SET_HOVER_MARGIN_TOP = 'SET_HOVER_MARGIN_TOP';
export const SET_HOVER_MARGIN_RIGHT = 'SET_HOVER_MARGIN_RIGHT';
export const SET_HOVER_MARGIN_BOTTOM = 'SET_HOVER_MARGIN_BOTTOM';
export const SET_HOVER_MARGIN_LEFT = 'SET_HOVER_MARGIN_LEFT';

export const SET_HOVER_PADDING = 'SET_HOVER_PADDING';
export const SET_HOVER_PADDING_TOP = 'SET_HOVER_PADDING_TOP';
export const SET_HOVER_PADDING_RIGHT = 'SET_HOVER_PADDING_RIGHT';
export const SET_HOVER_PADDING_BOTTOM = 'SET_HOVER_PADDING_BOTTOM';
export const SET_HOVER_PADDING_LEFT = 'SET_HOVER_PADDING_LEFT';

export const SET_HOVER_FONTSIZE = 'SET_HOVER_FONTSIZE';

export const SET_HOVER_TEXT = 'SET_HOVER_TEXT';
export const SET_HOVER_SELECTOR = 'SET_HOVER_SELECTOR';
